"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatedStateProxy = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const constants_1 = require("../../constants");
const constructs_1 = require("../../model/constructs");
const debug_1 = require("../lambda/debug");
const debug = debug_1.DEBUG_OVERRIDE || (debug_1.NOT_LAMBDA && false);
class CalculatedStateProxy {
    constructor(calculatedStateFn, thing) {
        this.datastore = {
            getAlertOrShadowHistory: () => {
                throw new Error('Not allowed in new versions');
            },
            getOne: async () => {
                debug && console.log('CalculatedStateProxy.getOne returning', constants_1.SYSTEM);
                return constants_1.SYSTEM;
            },
            getAllFromIndexWithHardLimit: async () => {
                return { Count: 0, ScannedCount: 0, Items: [] };
            },
            getWeatherByLocation: async (location, maxAgeMs) => {
                debug && console.log('proxy weather service');
                return { err: null, data: null };
            },
            createUpdate: async () => {
                throw new Error('TODO');
            },
        };
        this.calculatedStateFn = calculatedStateFn;
        this.thing = thing;
        this.objectHistory = constructs_1.ObjectHistory.createForObject(this.thing, {
            dailyStateHistory: true,
            recentStateHistory: true,
            monthlyStateHistory: true,
            weeklyStateHistory: true,
            yearlyStateHistory: true,
        });
    }
    async processTss(tss) {
        const calcStateRes = await this.calculatedStateFn(this.thing, tss, this.objectHistory, iotv_v3_types_1.proxyLogger);
        const updatedThing = calcStateRes.data?.updatedThingObject;
        if (updatedThing)
            this.thing = updatedThing;
        return calcStateRes;
    }
}
exports.CalculatedStateProxy = CalculatedStateProxy;
